import AppComponent from '../../mixins/app-component'

import AppIcon from '../app-icon'

export default
{
    name: 'app-home-footer-item',

    mixins: [
        AppComponent
    ],

    components: {
        AppIcon
    },

    props: {
        type: { type: String, default: 'number' },
        activeIndex: { type: Number, default: 0 },
        label: { type: String, default: '' },
        index: { type: Number, default: 0 },
        disabled: { type: Boolean, default: false }
    },

    computed: {
        labelArray() {
            return this.label.split(' ')
        }
    },

    data() {
        return {
            indexFormatted: null,
            wrapperElement: null,
            numberElement: null,
            numberWidth: 0,
            labelElement: 0,
            labelWidth: 0
        }
    },

    created() {
        if (this.type === 'number') {
            if (this.index < 10) {
                this.indexFormatted = String(`0${this.index}`)
            } else {
                this.indexFormatted = String(this.index)
            }
        }

        // this.eventHub.$on('app-home-footer:mouseenter', this.onFooterMouseenter)
        // this.eventHub.$on('app-home-footer:mouseleave', this.onFooterMouseleave)
    },

    mounted() {
        this._getSizeOfElements()
    },

    destroyed() {
        // this.eventHub.$off('app-home-footer:mouseenter', this.onFooterMouseenter)
        // this.eventHub.$off('app-home-footer:mouseleave', this.onFooterMouseleave)
    },

    methods: {
        _getSizeOfElements() {
            this.wrapperElement = document.querySelector(`.js-home-footer-item-wrapper--${this.index}`)
            this.numberElement = document.querySelector(`.js-home-footer-item-number--${this.index}`)
            this.labelElement = document.querySelector(`.js-home-footer-item-label--${this.index}`)

            if (this.numberElement && this.labelElement) {
                this.numberWidth = this.numberElement.offsetWidth
                this.labelWidth = this.labelElement.offsetWidth
            }
        },

        changeActiveIndexTo(index) {
            if (!this.disabled) this.eventHub.$emit('page-home:changeActiveIndexTo', index)
        },

        onPrevSlide() {
            if (!this.disabled) this.eventHub.$emit('page-home:onPrevSlide')
        },

        onNextSlide() {
            if (!this.disabled) this.eventHub.$emit('page-home:onNextSlide')
        }

        // onFooterMouseenter() {
        //     if (this.numberElement && this.labelElement && !this.$root.isTouch && this.$root.width > 770) {
        //
        //     }
        // },
        //
        // onFooterMouseleave() {
        //     if (this.numberElement && this.labelElement && !this.$root.isTouch && this.$root.width > 770) {
        //
        //     }
        // }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-home-footer-item/script.js